import { Styles } from '@types'
import { Button } from 'antd'
import { ButtonType } from 'antd/lib/button'

export type PageTitleAction = {
  label: string
  onClick: () => void
  buttonType?: ButtonType
  color?: string
  disabled?: boolean
}

type Props = {
  title: string
  actions?: PageTitleAction[]
}
export default function PageTitle({ title, actions = [] }: Props): JSX.Element {
  return (
    <div style={styles.div}>
      <div style={styles.title}>{title}</div>
      <div style={styles.actionsContainer}>
        {actions.map(({ label, buttonType, disabled, onClick }) => (
          <Button key={label} type={buttonType} onClick={onClick} style={styles.button} disabled={disabled}>
            {label}
          </Button>
        ))}
      </div>
    </div>
  )
}

const styles: Styles = {
  div: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingTop: '20px',
    paddingBottom: '10px',
    paddingLeft: '10px',
    paddingRight: '10px',
  },
  title: { fontSize: 22, fontWeight: 'bold' },
  actionsContainer: { display: 'flex', alignItems: 'center' },
  button: { marginLeft: '10px' },
}
